module.exports = __webpack_public_path__ + "img/banner_bg_4.73c95d1f.png";